import React, { forwardRef, useEffect } from 'react';
import moment from 'moment';
import { toAbsoluteUrl } from '../../_metronic/helpers';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { displayValueForTimeEntry, getColumnSum } from '../../common/timesheetFunction';
import { t } from 'i18next';
import { format, parse } from 'date-fns';
import { getAndSetCustomFieldValues, formatNumberCustomoriginalapiv2, formatCurrntDateTime, formatDateWithDateAndMonthName, FormatInvoiceDecimalNumber, getValueFromResource } from '../../common/timeLiveFunction';

const TimesheetPrintWidget = forwardRef((props: any, ref: any) => {
    const dispatch = useAppDispatch();
    const { customFieldsArray, timeEntryDetailArray, datePrintHeaderArray, commentsArray, logoPath, eSignURL, isForTimesheet, rowAccountEmployeeIdForPrint,status } = props   
    const { startDate, endDate, employeeList, timesheetStatus, totalHours, isTimesheetPolicy,  accountEmployeeId, submittedDate, noOfWorkingDays } = useAppSelector((state) => state.timesheet);
    const { cultureInfoName, isCompanyOwnLogo, timesheetPrintFooter, isShowElectronicSign, CurrentCultureDateFormat, showTimeOffInTimesheet, HighlightTimeEntriesBy,decimalPlaces , decimalFormat } = useAppSelector(state => state.globalState);
    let tempHeaderArray: any[] = [];
    let tempDetailArray: any[] = [];
    let chunkSize = 0;
    if (datePrintHeaderArray.length > 0) {
        chunkSize = datePrintHeaderArray.length <= 7 ? 7 : noOfWorkingDays;//Math.ceil(datePrintHeaderArray.length / 5);
    } else {
        chunkSize = 0;
    }
    // let chunkSize = 5;
    let tempRowId = 0;
    let counter = 0;
    for (let i = 0; i < datePrintHeaderArray.length; i += chunkSize) {
        tempHeaderArray.push(datePrintHeaderArray.slice(i, i + chunkSize));
    }
    for (let k = 0; k < timeEntryDetailArray.length; k++) {
        for (let j = 0; j < timeEntryDetailArray[k].timeEntries.length; j += chunkSize) {
            tempDetailArray.push(timeEntryDetailArray[k].timeEntries.slice(j, j + chunkSize));
        }
    }
    timeEntryDetailArray.map((items: any) => {
        tempDetailArray.map((item: any, index: number) => {
            if (items.rowId == item[0].rowId) {
                if (tempRowId == item[0].rowId) {
                    tempRowId = item[0].rowId;
                    item.indexes = counter;
                    counter = (counter + 1);
                }
                else {
                    tempRowId = item[0].rowId;
                    counter = 0;
                    item.indexes = 0;
                    counter = (counter + 1);
                }
            }
        })
    });

    useEffect(() => {

    }, []);

    let captionFieldsArray: any;
    if (commentsArray.length > 0) {
        captionFieldsArray = Object.entries(commentsArray[0])
            .filter(([key, value]) => key.startsWith("CaptionCustomField"))
            .map(([key, value]) => ({ [key]: value }));
    }

    return (
        <>
            <style>
                {`@media print {
                    @page:first {
                        margin-top: 0mm;
                    }
                    @page {
                        size: landscape;
                        margin-top: 6mm;
                        margin-bottom: 6mm;
                    }
                    thead {
                        display: table-row-group !important;
                    }
                    body {
                        -webkit-print-color-adjust: exact;
                    }
                }`}
            </style>
            <div ref={ref}>
                <div className='modal-body pt-0 pb-15 px-5 px-xl-5'>
                    <div className='row text-left mb-13' style={{ marginTop: 25, pageBreakInside: 'avoid', breakInside: 'avoid' }}>
                        {/* <img src={toAbsoluteUrl('/media/logos/livetecs-Icon.svg')} className='tsReportIcon'></img>
                        <img src={toAbsoluteUrl('/media/logos/livetecs.svg')} className='tsReportLogo'></img> */}
                        {/* {isCompanyOwnLogo && <img
                                        src={logoPath}
                                        alt={logoPath} style={{ width: '180px', height: '50px' }} /> :
                                        <img src={toAbsoluteUrl('/media/logos/livetecs-Icon.svg')} className='tsReportIcon'></img>
                        <img src={toAbsoluteUrl('/media/logos/livetecs.svg')} className='tsReportLogo'></img>} */}
                        {isCompanyOwnLogo ?
                            <img src={props.logoPath} className='tsReportIcon' style={{ width: '180px', height: '50px', paddingLeft: 20, marginBottom: 8 }} />
                            :
                            <>
                                {/* <img src={toAbsoluteUrl('/media/logos/livetecs-Icon.svg')} className='tsReportIcon' /> */}
                                <img src={toAbsoluteUrl('/media/logos/LivetecsLogo.svg')} className='tsReportLogo' />
                            </>
                        }
                        <span className='textDarkBlue' style={{ fontWeight: 600, fontSize: 20 }}>
                            {/* {t('Timesheet Summary')} */}
                            {getValueFromResource('Timesheet Summary', dispatch, t)}
                        </span>
                        {isForTimesheet ? <span className='lightGray' style={{ fontWeight: 500, fontSize: 14, marginLeft: 1 }}>{`${formatDateWithDateAndMonthName(startDate, cultureInfoName.toString())}  -  ${formatDateWithDateAndMonthName(endDate, cultureInfoName.toString())}`}</span> :
                            <span className='reportText'>{timeEntryDetailArray.length > 0 ? timeEntryDetailArray[0].timesheetDate : ""}</span>}

                        <div style={{ marginLeft: -5, marginTop: 20 }}>
                            <span className='reportLabel' style={{ paddingLeft: 6 }}>
                                {/* {t('Total Hours:')} */}
                                {getValueFromResource('Total Hours:', dispatch, t)}
                            </span>
                            <span className='reportText'>
                                {timeEntryDetailArray.length > 0
                                    ? decimalFormat
                                        ? FormatInvoiceDecimalNumber(
                                            cultureInfoName.toString(),
                                            Number(timeEntryDetailArray[0].totalHours),
                                            2
                                        )
                                        : displayValueForTimeEntry(timeEntryDetailArray[0].totalHours, isTimesheetPolicy, decimalFormat).toString()//timeEntryDetailArray[0].totalHours
                                    : 0}
                                </span>
                            <span className='reportLabel'>
                                {/* {t('Status:')} */}
                                {getValueFromResource('Status', dispatch, t) + ":"}
                            </span>
                            {/* <span className='reportText'>
                                {timesheetStatus.text}
                                </span> */}
                                <span className="tsDetailModalText">
                                                {(isForTimesheet ? timesheetStatus.text :
                                                   status)}
                                                   
                                            </span> 
                            <span className='reportLabel'>
                                {/* {t('Employee Name:')} */}
                                {getValueFromResource('Employee Name:', dispatch, t)}
                            </span>

                            {isForTimesheet ?
                                <span className='reportText'>{accountEmployeeId > 0 && employeeList?.filter((x:any) => x?.AccountEmployeeId == accountEmployeeId.toString())[0]?.EmployeeName}</span> :
                                <span className='reportText'>{timeEntryDetailArray.length > 0 ? timeEntryDetailArray[0]?.employeeName : ""}</span>}


                        </div>
                    </div>
                    {tempHeaderArray.length > 0 && tempHeaderArray.map((headerChunk: any, chunkIndex: number) => {
                        const chunkDetailArrays = tempDetailArray.filter((item: any) => item.indexes === chunkIndex);
                        const chunkColumnTotals = headerChunk.map((_: any, colIndex: number) => {
                            return timeEntryDetailArray.reduce((sum: number, row: any) => {
                                const entryIndex = chunkIndex * chunkSize + colIndex;
                                if (row.timeEntries && row.timeEntries[entryIndex]) {
                                    return sum + (row.timeEntries[entryIndex].Hours || 0);
                                }
                                return sum;
                            }, 0);
                        });

                        const chunkRowTotals = chunkDetailArrays.map((detailRow: any) => {
                            return detailRow.reduce((sum: number, entry: any) => sum + (entry.Hours || 0), 0);
                        });

                        return (
                            <div className='tableContainer' style={{
                                marginTop: 25,
                                pageBreakInside: 'auto',
                                breakInside: 'auto',
                            }}>
                                <div className='tsDetailTableMainDiv'>
                                    <table style={{ width: '100%', maxWidth: '100%' }}>
                                        <thead>
                                            <tr>
                                                <th style={{ height: 57 }}>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {timeEntryDetailArray.map((item: any, index: number) => (
                                                <tr key={index} >
                                                    <td className='tsReportInfoTbody'>
                                                        {(item.timeType != null && item.timeType === 'Time Off') ? (
                                                            <>
                                                                <span className="projectTaskHeading"></span><br></br>
                                                                <span className='tsReportInfoSpan'>
                                                                    {item.timeType + ' • ' + item.accountTimeOffType}
                                                                </span>
                                                            </>
                                                        ) : (
                                                            <>
                                                            {HighlightTimeEntriesBy === 'Client' ? (
                                                                 <>
                                                                        <span className="projectTaskHeading">{item.partyName}</span><br />
                                                                        <span className='tsReportInfoSpan'>
                                                                            {(item.accountCostCenter != null) ? item.projectName + ' • ' + item.taskName + ' • ' + item.accountCostCenter :
                                                                                item.projectName + ' • ' + item.taskName}
                                                                        </span>
                                                                        </>
                                                            ) : (
                                                                <>
                                                                    <span className="projectTaskHeading">{item.taskName}</span><br></br>
                                                                    <span className='tsReportInfoSpan'>
                                                                        {(item.accountCostCenter != null) ? item.partyName + ' • ' + item.projectName + ' • ' + item.accountCostCenter : item.partyName + ' • ' + item.projectName}
                                                                    </span>
                                                                </>
                                                            )}
                                                            </>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className={"datePanelForTimesheetPrint tableContainerCol"}>
                                    <table id='tblHoursInput' className={"table data-table"} >
                                        <thead>
                                            <tr>
                                                {headerChunk.map((item: any, index: number) => {
                                                    return (
                                                        <th style={{ backgroundColor: '#f0f1f4', width: 60, color: '#172b4d', fontWeight: 600, fontSize: 13, textTransform: "uppercase" }} key={index}>
                                                            <div>
                                                                <div>
                                                                    <span>{item.split('<br>')[0]}</span>
                                                                </div>
                                                                <span className='tsHeaderDateLabel'>{item.split('<br>')[1]}</span>
                                                            </div>
                                                        </th>
                                                    )
                                                })}
                                                <th style={{ backgroundColor: '#f0f1f4', color: '#172b4d', fontWeight: 600, fontSize: 12, textTransform: "uppercase", verticalAlign: 'middle' }}>
                                                    <span>Total</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {chunkDetailArrays.map((item: any, i: number) => {
                                                return (
                                                    <>
                                                        <tr key={i} className='timesheet-row'>
                                                            {item.map((items: any, b: number) =>
                                                                <td key={b} style={{ height: 56, width: 45, padding: 10, verticalAlign: 'middle', border: '0.6px solid #f2f2f2', color: '#172b4d', fontWeight: 600, fontSize: 15 }}>
                                                                    <span className='duration-value'>{decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), (items?.Hours), 2) : displayValueForTimeEntry(items?.Hours, isTimesheetPolicy, decimalFormat)}</span>
                                                                    {/* <span className='duration-value'>{displayValueForTimeEntry(items?.Hours, isTimesheetPolicy, decimalFormat)}</span> */}
                                                                </td>
                                                            )}
                                                            <td style={{ height: 56, padding: 10, verticalAlign: 'middle', border: '0.6px solid #f2f2f2', color: '#172b4d', fontWeight: 600, fontSize: 15 }}>
                                                                <span className='duration-value'>{decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), (chunkRowTotals[i]), 2):displayValueForTimeEntry(chunkRowTotals[i], isTimesheetPolicy, decimalFormat)}</span>
                                                            </td>
                                                        </tr>
                                                        {/* footer */}
                                                        {i === chunkDetailArrays.length - 1 && timeEntryDetailArray.length > 0 && (
                                                            <tr className={"timesheet-row total-row dark"}>
                                                                {chunkColumnTotals.map((total: any, colIndex: any) =>
                                                                    <td key={colIndex} style={{ padding: 0 }}>
                                                                        <div className='tsDetailTableFooter'>
                                                                            <span className={"footer-duration-value"}>{decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), (total), 2) :displayValueForTimeEntry(total, isTimesheetPolicy, decimalFormat)}</span>
                                                                        </div>
                                                                    </td>)}
                                                                <td style={{ padding: 0 }}>
                                                                    <div className='tsDetailTableFooter'>
                                                                        <span className={"footer-duration-value"}>
                                                                            
                                                                            {decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), (chunkColumnTotals.reduce((sum: number, val: number) => sum + val, 0)), 2) :displayValueForTimeEntry(
                                                                                chunkColumnTotals.reduce((sum: number, val: number) => sum + val, 0),
                                                                                isTimesheetPolicy,
                                                                                decimalFormat
                                                                            )}
                                                                        </span>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </>
                                                )
                                            })}
                                        </tbody>
                                        {/* {
                                            timeEntryDetailArray.length > 0 &&
                                            <tfoot>
                                                <tr className={"timesheet-row total-row dark"}>
                                                    {chunkColumnTotals.map((total: any, i: any) =>
                                                        <td key={i} style={{ padding: 0 }}>
                                                            <div className='tsDetailTableFooter'>
                                                                <span className={"footer-duration-value"}>{displayValueForTimeEntry(total, isTimesheetPolicy, decimalFormat)}</span>
                                                            </div>
                                                        </td>)}
                                                    <td style={{ padding: 0 }}>
                                                        <div className='tsDetailTableFooter'>
                                                            <span className={"footer-duration-value"}>
                                                                {displayValueForTimeEntry(
                                                                    chunkColumnTotals.reduce((sum: number, val: number) => sum + val, 0),
                                                                    isTimesheetPolicy,
                                                                    decimalFormat
                                                                )}
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        } */}
                                    </table>
                                </div>
                            </div>
                        )
                    })}
                    <div className='text-left mb-1'>
                        <span className='commentHeading'>
                            {/* {t('Comments List')} */}
                            {getValueFromResource('Comments List', dispatch, t)}
                        </span>
                    </div>
                    <table className='tsReportCommentTable'>
                        <thead>
                            <tr className='tsReportCommentThead'>
                                {/* <th style={{ paddingLeft: 10, width: '35%' }}>{t('Project Name • Task Name')}</th>
                                <th style={{ width: '20%' }}>{t('Time Entry Date')}</th>
                                <th style={{ width: '20%' }}>{t('Total Time')}</th> */}
                                <th style={{ paddingLeft: 10 }}>
                                    {/* {t('Project Name • Task Name')} */}
                                    {getValueFromResource('Project Name • Task Name', dispatch, t)}
                                </th>
                                <th>
                                    {/* {t('Time Entry Date')} */}
                                    {getValueFromResource('Time Entry Date', dispatch, t)}
                                </th>
                                <th>
                                    {/* {t('Total Time')} */}
                                    {getValueFromResource('Total Time', dispatch, t)}
                                </th>
                                <th>
                                    {/* {t('Description')} */}
                                    {getValueFromResource('Description', dispatch, t)}
                                </th>
                                {
                                    captionFieldsArray != undefined && captionFieldsArray.map((item: any, index: any) => {
                                        return (
                                            <th>
                                                {Object.values(item)}
                                            </th>
                                        )
                                    })
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {commentsArray.map((item: any, index: number) => {
                                let count = 1;
                                return (
                                    <tr key={index} className='tsReportCommentTbody'>
                                        {(item.AccountTimeOffType != null && item.IsTimeOff === true) ? (
                                            <td style={{ paddingLeft: 10 }}>
                                                {/* {t('Time Off •')}  */}
                                                {getValueFromResource('Time Off •', dispatch, t)}
                                                {item.AccountTimeOffType}</td>
                                        ) : (
                                            <td style={{ paddingLeft: 10 }}>{item.ProjectName + ' • ' + item.TaskName}</td>
                                        )}
                                        {/* <td>{moment.parseZone(item.TimeEntryDate).format('YYYY-MM-DD')}</td> */}
                                        {/* <td>{format(item.TimeEntryDate, CurrentCultureDateFormat.toString())}</td> */}
                                        <td>{formatDateWithDateAndMonthName(item.TimeEntryDate, cultureInfoName.toString())}</td>
                                        <td>{decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), (item.Hours), 2) :item.FormattedTotalTime}</td>
                                        <td>{item.Description}</td>
                                        {captionFieldsArray != undefined && Object.keys(item)
                                            .filter(key => key.startsWith('CustomField'))
                                            .map((key, index) => {
                                                if (index >= captionFieldsArray.length) return null;

                                                const formattedValue = getAndSetCustomFieldValues(key, item[key], customFieldsArray, cultureInfoName.toString(), decimalPlaces);
                                                return <td key={key}>{formattedValue}</td>;
                                            })
                                        }
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                    <div className='row mt-2'>
                        <textarea defaultValue={timesheetPrintFooter.toString()} rows={10} style={{ borderRadius: 0, borderStyle: 'none' }}>
                        </textarea>
                    </div>
                    {isShowElectronicSign && eSignURL &&
                        <div id="electronicSignature">
                            <div className='text-left mb-2'>
                                <span className='commentHeading'>
                                    {/* {t('Electronic Signature')} */}
                                    {getValueFromResource('Electronic Signature', dispatch, t)}
                                </span>
                            </div>
                            <div className='text-left mb-1'>
                                <span className='reportLabel' style={{ paddingLeft: 0 }}>
                                    {/* {t('Signed By')} */}
                                    {getValueFromResource('Signed By', dispatch, t)}
                                </span>
                                <span className='reportText'>{accountEmployeeId > 0 && employeeList.filter(x => x.AccountEmployeeId == accountEmployeeId.toString())[0].EmployeeName}</span>
                            </div>
                            {eSignURL &&
                                <div className='text-left mb-1'>
                                    <span className='reportLabel' style={{ paddingLeft: 0, paddingRight: 6 }}>
                                        {/* {t('Signature')} */}
                                        {getValueFromResource('Signature', dispatch, t)}
                                    </span>
                                    <img id="imgElectronicSignature" alt="" src={eSignURL} style={{ height: '50px' }} />
                                </div>
                            }
                            <div className='text-left mb-1'>
                                <span className='reportLabel' style={{ paddingLeft: 0 }}>
                                    {/* {t('Printed On')} */}
                                    {getValueFromResource('Printed On', dispatch, t)}
                                </span>
                                {/* <span className="reportText">{moment().format('DD-MM-YYYY HH:mm:ss')}</span> */}
                                <span className="reportText"> {formatCurrntDateTime(new Date(), cultureInfoName.toString())}</span>
                            </div>
                            <div className='text-left mb-1'>
                                <span className='reportLabel' style={{ paddingLeft: 0 }}>
                                    {/* {t('Submitted By')} */}
                                    {getValueFromResource('Submitted By', dispatch, t)}
                                </span>
                                <span className="reportText">
                                    {(() => {
                                        if (!Array.isArray(timeEntryDetailArray) || timeEntryDetailArray.length === 0) {
                                            return getValueFromResource('No submissions', dispatch, t);
                                        }
                                        const submittedBy = timeEntryDetailArray.find((item: any) => item.submittedByName && item.submittedByName.trim() !== '')?.submittedByName;
                                  
                                        return submittedBy ? submittedBy : getValueFromResource('No submissions', dispatch, t);
                                    })()}
                                </span>

                                {/* <span className="reportText"> */}
                                {/* {timeEntryDetailArray.length > 0 ? (timeEntryDetailArray.map((item: any, index: number) => (
                                        <span className="reportText" key={index}>{item.submittedByName}</span>
                                    ))
                                    ) : (<span> */}
                                {/* No submissions */}
                                {/* {getValueFromResource('No submissions', dispatch, t)}
                                    </span>)}</span> */}
                            </div>
                            <div className='text-left mb-1'>
                                <span className='reportLabel' style={{ paddingLeft: 0 }}>
                                    {/* {t('Submitted Date')} */}
                                    {getValueFromResource('Submitted Date', dispatch, t)}
                                </span>
                                <span className="reportText">
                                    {(() => {
                                        if (!Array.isArray(timeEntryDetailArray) || timeEntryDetailArray.length === 0) {
                                            return getValueFromResource('No submissions', dispatch, t);
                                        }
                                        const validItem = timeEntryDetailArray.find((item: any) => item && item.submittedDate && moment(item.submittedDate).isValid());

                                        if (validItem) {
                                            return formatDateWithDateAndMonthName(validItem.submittedDate, cultureInfoName.toString());
                                        }

                                        return getValueFromResource('No submissions', dispatch, t);
                                    })()}
                                </span>

                                {/* <span className="reportText">{moment(timeEntryDetailArray.length > 0 && timeEntryDetailArray[0].submittedDate).format('M-D-YYYY')}</span> */}
                                {/* <span className="reportText">
                                    {timeEntryDetailArray.length > 0 ? (
                                        timeEntryDetailArray.map((item: any, index: number) => (
                                            <span className="reportText" key={index}>
                                                {item.submittedDate ? moment(item.submittedDate).isValid() ? moment.parseZone(item.submittedDate).format('M-D-YYYY') : getValueFromResource('Invalid Date', dispatch, t) : ''}
                                            </span>
                                        ))
                                    ) : (
                                        <span> */}
                                {/* No submissions */}
                                {/* {getValueFromResource('No submissions', dispatch, t)}
                                        </span>

                                    )} */}
                                {/* </span> */}
                            </div>
                        </div>
                    }
                </div>
            </div>
        </>
    )
});
export default TimesheetPrintWidget